import {create_title} from '@/base/titleData'
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    title: create_title('Video'),
    pop_video: { // 【弹窗视频】
      type: 'local_add', // 文件类型
      note: '',// 描述
      local_add: { // 【本地添加】
        url:  'https://staticjs.71360.com/3/static/txys-001/image/video.mp4', // 自定义链接地址
        name: ''
      },
      common_code: {// 【通用代码】
        url: '<iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=n0020yrnly7" allowFullScreen="true"></iframe>' // 通用代码
      },
      video_address: { // 【视频地址】
        url: 'https://staticjs.71360.com/3/static/txys-001/image/video.mp4' // 视频地址
      }
    },
    height: { // 高度
      radio_val: 'default',
      default:{
        height: '41.7%'
      },
      custom:{
        height: '41.7%'
      }
    },
    title_picture: { // 片头图片
      radio_val: 'default',
      default:{
        url: ''
      },
      custom:{
        url: ''
      }
    },
    play_mode: { // 播放方式
      radio_val: 'default',
      hidden_control: false,
      default:{
        url: '',
        loop: false,
        autoplay: false,
      },
      custom:{
        url: '',
        loop: false,
        autoplay: false,
      }
    },
    //文字设置
    text_set: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: 'normal',
        fontSize: 16,
        fontColor:'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      }
    },
    play_btn_url: 1
  },
  mb_widgets_infor: {
    title: create_title('Video')
  },
  listArr: {
   
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_video/style.js